import { MasterOfActsAPI } from "../../api/api";

const SET_DATA_LOCAL = "chartDeepAnaliticsReducer/SUCCESS_LOAD_COMPANIES";
const START_LOADING = 'chartDeepAnaliticsReducer/START_LOADING'
const ERROR_LOADING = 'chartDeepAnaliticsReducer/ERROR_LOADING'

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const crewDeepAnaliticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA_LOCAL:
      return {
        ...state,
        data: action.result,
        loading: false,
        error: null,
      };
    case START_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: null
      };
    case ERROR_LOADING:
      return {
        ...state,
        error: action.error,
        loading: false,
        data: [],
      };
    default:
      return state;
  }
};

export const startLoading = (payload) => ({type: START_LOADING, payload})
export const errorLoading = (error) => ({type: ERROR_LOADING, error})
export const setDataLocal = (result) => ({type: SET_DATA_LOCAL, result})

export const deepAnaliticsSelector = state => state.crewDeepAnaliticsReducer


export const loadingChartDeepAnalitics =
  (...content) => async (dispatch) => {
    
    try {
      dispatch(startLoading(true))
      const { name, startTime, endTime, localCompany, contractName, interval } = content[0]
      const response = await MasterOfActsAPI.getCompaniesChartDeepAnalytics(
        name,
        startTime,
        endTime,     
        localCompany,
        contractName,
        interval,
      );

      const dataObj = {
        KPI: [],
        n: [],
        w: [],
        r: [],
        t: [],
        NPT: [],
      }

      const time = new Date(startTime)

      if (response.status === 200 && typeof response.data === 'string') {
        throw new Error('Вы ввели некорректные данные')
      } 

      if (response.status === 200 && response.data.length !== 0 && typeof response.data !== 'string') {


        response.data.result.forEach((doot, index) => {
      

            let timemout = time.toLocaleDateString().slice(0, 7) + time.toLocaleDateString().slice(9)

            if (typeof doot !== 'string') {
              for(let [key, value] of Object.entries(doot)) {
                dataObj[key].push({name: timemout, [key]: value})
              }
            } else {
              ['KPI', 'n', 'w', 'r', 't', 'NPT'].forEach(key => {
                if (key === 'KPI') {
                  dataObj[key].push({name: timemout, [key]: 100})
                } else {
                  dataObj[key].push({name: timemout, [key]: 0})
                }
                
              }) 
            }            
            if (interval === 'month') {
              time.setMonth(time.getMonth() + 1)
            } else if (interval === 'week') {
              time.setDate(time.getDate() + 7)
            } 
          }); 
        dispatch(setDataLocal(dataObj))
      } else {
        dispatch(errorLoading(response.data))
      }
      dispatch(startLoading(false))
    } catch(error) {
        dispatch(errorLoading(error.message))
    }
    
  };